import { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

import { useInstantNotifier } from "../../Notifier/useInstantNotifier";
import { IInstantNotification } from "../../Notifier/types";


interface SnackBarInstantNotifierProps {
    autoHideDurationMs: number | null | undefined; 
}

const SnackBarInstantNotifier = (props: SnackBarInstantNotifierProps) => {

    const notifier = useInstantNotifier();

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => setIsOpen(notifier.items.length > 0), [notifier.items]);

    const currentItem: IInstantNotification | null = notifier.items[0] ?? null;

    const handleClose = () => notifier.pop();

    return (
        <>
        {!!currentItem && 
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={props.autoHideDurationMs}
                open={isOpen}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity={currentItem?.style ?? 'info'} variant="filled" sx={{ width: '100%' }}>{currentItem?.text ?? ''}</Alert>
            </Snackbar>
        }
        </>
    );
};

export default SnackBarInstantNotifier;